import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const ProtectedRoute = ({ children, state }: any) => {
  const store = useSelector((state: any) => state.user)
  const { userState } = store
  const navigate = useNavigate()

  useEffect(() => {
    if (userState[state].status === 'PENDING' || userState[state].status === 'COMPLETE') {
      navigate('/registration-status')
    }
  }, [userState])

  return children
}

export default ProtectedRoute
